export const numEmployeesOptions = [
  { name: '0-50', value: '0-50' },
  { name: '50-100', value: '50-100' },
  { name: '100-500', value: '100-500', isEnterprise: true },
  { name: '500-1000', value: '500-1000', isEnterprise: true },
  { name: '1000-5000', value: '1000-5000', isEnterprise: true },
  { name: '5000+', value: '5000+', isEnterprise: true }
]
